import { useNavigate } from 'react-router-dom';
import { useI18n } from '../lib/i18n';
import Icon from './Icon';

// Fiskalna kasa još ne postoji — stranica "U izradi" umesto forme
export default function FiscalComingSoon({ variant = 'fiscal' }) {
  const { tr } = useI18n();
  const isAdvance = variant === 'avans';
  const navigate = useNavigate();
  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <span style={styles.icon}><Icon name={isAdvance ? 'receipt' : 'calculator'} size={30} /></span>
        <span style={styles.tag}>{tr('U izradi', 'In progress', 'В разработке')}</span>
        <h1 style={styles.title}>{isAdvance ? tr('Avansi', 'Advance invoices', 'Авансы') : tr('Fiskalna kasa', 'Fiscal register', 'Фискальная касса')}</h1>
        <p style={styles.text}>
          {isAdvance
            ? tr('Uskoro ćete ovde izdavati avansne račune kada klijent plati unapred, i uračunavati ih u konačnu fakturu.',
              'Soon you will issue advance invoices here and deduct them on the final invoice.',
              'Скоро здесь можно будет выставлять авансовые счета.')
            : tr('Uskoro ćete ovde moći da izdajete fiskalne račune povezane sa Poreskom upravom.',
              'You will soon be able to issue fiscal receipts connected to the Tax Administration here.',
              'Скоро здесь можно будет выдавать фискальные чеки.')}
        </p>
        <div style={styles.btns}>
          <button onClick={() => navigate(-1)} style={styles.primary}>
            <Icon name="arrowLeft" size={15} />{tr('Nazad', 'Back', 'Назад')}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: { maxWidth: 560, margin: '24px auto' },
  card: { background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 10, padding: '36px 24px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 12 },
  icon: { width: 72, height: 72, borderRadius: '50%', background: 'var(--paper)', color: 'var(--teal-800)', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  tag: { fontSize: 12, fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--gold-600)', background: 'var(--gold-100)', borderRadius: 999, padding: '4px 12px' },
  title: { margin: 0, fontSize: 22, fontWeight: 800, color: 'var(--ink-900)' },
  text: { margin: 0, fontSize: 15, lineHeight: 1.55, color: 'var(--ink-700)', maxWidth: 420 },
  btns: { display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center', marginTop: 8 },
  primary: { display: 'flex', alignItems: 'center', gap: 6, minHeight: 34, border: 'none', borderRadius: 8, background: 'var(--teal-800)', color: '#fff', padding: '0 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer' },
};
